export default __webpack_public_path__ + "static/media/interaction02.fcb02a9f.png";